import React, { useState, useRef, useContext, useEffect } from "react"
import Button from "../UI/button/Button"
import { Context } from "../../components/store/UserProvider"
import * as Style from "./Discussion.module.scss"
import useComments from "../custom_hooks/use-comments"
import useValidateComment from "../custom_hooks/use-validateComments"
import ExcIcon from "../../images/exclamation.svg"
import ArrowForward from "../../images/input-icons/arrow_forward.svg"

const Discussion = props => {
  const ctx = useContext(Context)
  const br =
    typeof document !== `undefined` ? document.createElement("br") : null
  let localUser
  if (typeof window !== "undefined") {
    localUser = localStorage.getItem("MontesoriUser")
  }
  const [comment, setComment] = useState("")
  const tArea = useRef("")
  let commentValue = tArea.current.value
  const textAreaSize = () => {
    if (tArea.current) {
      tArea.current.style.height = "5px"
      tArea.current.style.height = tArea.current.scrollHeight + "px"

      if (commentValue && commentValue.length >= 240) {
        tArea.current.style.borderBottomColor = "red"
      } else {
        tArea.current.style.borderBottomColor = "#73C6E3"
      }
    }
  }
  const getCommentValue = event => {
    setComment(event.target.value)
    validateHandler(event.target.value)
  }

  const { sendData } = useComments(
    comment,
    props.strapi_id,
    props.mode,
    props.mainId,
    props.user_name,
    props.original_post,
    props.nav_id
  )

  const {
    validateHandler,
    submithandler,
    resetValidate,
    blurCounter,
    removeBlock,
    inputState,
  } = useValidateComment()

  const sendDatahandler = () => {
    submithandler()
    if (inputState.comment.valid) {
      sendData()
      if (props.mode === "reply-main" || props.mode === "reply-sub") {
        props.close()
      }
      setComment("")
      resetValidate()
    }
  }

  // const closeDis = () => {
  //   props.blurHandler()
  // }

  useEffect(() => {
    if (props.mode === "reply-main" || props.mode === "reply-sub") {
      if (inputState.comment.counter !== 0 && !inputState.comment.block) {
        props.blurHandler()
        resetValidate()
      } else if (inputState.comment.submit) {
        setTimeout(() => {
          tArea.current.focus()
          removeBlock()
        }, 300)
      }
    }
  }, [inputState.comment.counter])

  useEffect(() => {
    if (props.showReply) {
      tArea.current.focus()
    }
  }, [props.showReply])

  return (
    <div
      className={`${Style.discussion_wrapper} ${
        props.mode === "reply-main" || props.mode === "reply-sub"
          ? Style.discussion_wrapper_sub
          : ""
      }`}
    >
      {!props.mode && <h3 className={Style.title}>{props.discussion.title}</h3>}
      <div className={Style.wrapper}>
        <div className={Style.avatar}></div>
        <div className={Style.inputWrap}>
          <div className={Style.counter}>{comment.length}/240</div>
          <textarea
            onBlur={blurCounter}
            value={comment}
            type="text"
            maxLength="240"
            className={Style.tArea}
            ref={tArea}
            placeholder={props.discussion.comment}
            onInput={textAreaSize()}
            onChange={getCommentValue}
          />
          {comment.length >= 240 ? (
            <h3 className={Style.limitErrorMessage}>Твърде дълъг коментар !</h3>
          ) : (
            ""
          )}
        </div>
        <Button style={Style.button} mouseDownHandler={sendDatahandler}>
          <p className={Style.btnText}>{props.discussion.post_button} </p>
          <div className={Style.btnArrowWrapper}>
            <ArrowForward />
          </div>
          {/* <GatsbyImage
                    image={getImage(
                        props.btnArrow
                    )}
                    alt="->" /> */}
        </Button>
      </div>
      {!inputState.comment.valid && inputState.comment.submit && (
        <div
          className={`${Style.commentsErrorWrapper} ${
            props.mode === "main" ? Style.commentsErrorWrapperMain : ""
          }`}
        >
          <ExcIcon />
          <p>Празен коментар</p>
        </div>
      )}
    </div>
  )
}

export default Discussion
